import type { VoicePreference } from './voice/preference';

type VoicePickerProps = {
  value: VoicePreference;
  onChange: (voice: VoicePreference) => void;
};

const OPTIONS: readonly { value: VoicePreference; label: string }[] = [
  { value: 'off', label: 'Sin voz' },
  { value: 'mujer', label: 'Mujer' },
  { value: 'hombre', label: 'Hombre' },
];

/** Who reads the team's answers aloud: nobody, a woman or a man. Picking one plays the line on screen in it. */
export function VoicePicker({ value, onChange }: VoicePickerProps) {
  return (
    <div className="agents-voice" role="group" aria-label="Voz de tu equipo" data-on={value !== 'off' || undefined}>
      <SpeakerIcon on={value !== 'off'} />
      {OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          className="agents-voice-option"
          aria-pressed={value === option.value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

function SpeakerIcon({ on }: { on: boolean }) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
      <path d="M4 8h2.5L10 5v10l-3.5-3H4z" fill="currentColor" />
      {on ? (
        <path d="M13 7.5a3.5 3.5 0 0 1 0 5M15 5.5a6.5 6.5 0 0 1 0 9" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      ) : (
        <path d="m13 8 4 4m0-4-4 4" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      )}
    </svg>
  );
}
